import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    container: {
      margin: '16px 0 28px 0',
    },
    searchBar: {
      '& form': {
        height: 35,
        margin: 0,
      },

      '& .MuiInputBase-input': { padding: 0 },
    },
    buttonsContainer: {
      display: 'flex',
      gap: '8px',
    },
    cleanContainer: {
      display: 'flex',
    },
    cleanButton: {
      color: palette.red,
      height: 32,
      padding: '0px 14px',

      '&:hover': {
        backgroundColor: palette.superLightRed,
      },
    },
  });
